import { UtilityModule } from "@/core/modules/utility/objects/UtilityModule";

import AssignEmployeeDutyView from "./views/AssignEmployeeDutyView.vue";

export const assignEmployeeDuty: UtilityModule = new UtilityModule("healthProtocol", "AssignEmployeeDuty", "utility", AssignEmployeeDutyView);
